import Vue from "vue";
import $ from "jquery";

import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import EstateOverview from "../../vue-components/EstateOverview.vue";

import SweepBright from "../../../../plugins/wp-sweepbright/dist/wp-sweepbright-public";

const estateOverview = () => {
	$(".estate-overview").each((index, el) => {
		Vue.config.productionTip = false;
		Vue.config.devtools = false;

		Vue.use(SweepBright);

		Vue.use(VueGoogleMaps, {
			load: {
				key: "AIzaSyD5l9tULwAjtCepaEn8IcMpVrYGO8LeHL4",
				libraries: "places"
			}
		});
		Vue.component("GmapCluster", GmapCluster);
		Vue.component("v-select", vSelect);

		new Vue({
			el: `.${el.className}`,
			render: h =>
				h(EstateOverview, {
					props: {
						component: $(el).data("component")
					}
				})
		});
	});
};

export default estateOverview;
